import React from 'react';
import { formatter } from "../../../../utility";

const RentIncreaseBreakdown = (props) => {
  const { 
    decisionEligibleAmount, 
    rentAmountUsedForCalc, 
    rentCPIAmountStandardRentIncrease, 
    rentAmountStandardRentIncrease,
    rentAmountAdditionalPortion,
    rentAmountFinalAdditionalRentIncrease,
    rentMaxAmountAdditionalPortion,
    calcRentIncreaseCausedLoss,
    calcRentIncreaseServiceTimeIsAvailable,
    calcMissedRentIncreaseDate,
    cpiValue,
    cpiYear 
  } = props;

  const renderAllowedRentIncreaseAmount = () => {
    if ((calcRentIncreaseCausedLoss || !calcRentIncreaseServiceTimeIsAvailable) && calcMissedRentIncreaseDate) return;
      return (
        <div className="w1-step-three__wrapper">
          <span className="w1-step-three__value--result">{formatter.toAmountDisplay(rentAmountFinalAdditionalRentIncrease)}</span>
          <span>Maximum allowed rent amount with all rent increases applied (the annual allowable rent increase and additional rent increase)</span>
        </div>
      );
  }

  return (
    <>
      <div className="w1-step-three__increase-breakdown">
        <div className="w1-step-three__wrapper">
          <span className="w1-step-three__value--disabled">{formatter.toAmountDisplay(decisionEligibleAmount)}</span>
          <span className="w1-step-three__label--disabled">Eligible amount from the decision for the unit</span>
        </div>

        <div className="w1-step-three__wrapper">
          <span className="w1-step-three__value">{formatter.toAmountDisplay(rentAmountUsedForCalc)}</span>
          <span>Current monthly rent (before any rent increases)</span>
        </div>

        <div className="w1-step-three__wrapper">
          <span className="w1-step-three__value">{formatter.toAmountDisplay(rentCPIAmountStandardRentIncrease)}</span>
          <span>Maximum annual allowable rent increase amount {!cpiValue || !cpiYear ? null : `(${cpiValue}% for ${cpiYear})` }</span>
        </div>

        <div className="w1-step-three__wrapper">
          <span className="w1-step-three__value">{formatter.toAmountDisplay(rentAmountStandardRentIncrease)}</span>
          <span>Rent amount with maximum annual allowable rent increase </span>
        </div>

        <div className="w1-step-three__wrapper">
          <span className="w1-step-three__value">{formatter.toAmountDisplay(rentAmountAdditionalPortion)}</span>
          <span>Additional rent increase amount eligible for Phase 1 (capped at a max of 3% of rent after the annual allowable rent increase is applied or {formatter.toAmountDisplay(rentAmountAdditionalPortion)})</span>
        </div>

        {renderAllowedRentIncreaseAmount()}
      </div>
    </>
  )
}

export default RentIncreaseBreakdown;